/** Minimal className merge (shadcn-style). Install clsx + tailwind-merge for full merge. */
export function cn(...inputs) {
    return inputs
        .flat()
        .filter(Boolean)
        .join(" ")
        .trim();
}
